<template>
    <div class="product_shelves_wrap">
        <div class="product_shelves_left category category_38">
            <div class="category_top" :class="{'active':activeGroupingId == 0}" @click="handleClickGroupingItem({id:0,name:''})" >
                <p>全部产品</p>
                <el-tooltip class="item" effect="dark" content="添加分组" placement="top">
                    <span @click="handleClickAddGrouping()" class="handle_icon_wrap"><i class="el-icon-circle-plus-outline"></i></span>
                </el-tooltip>

            </div>
            <div class="category_bottom" :class="{'noActiveTree':activeGroupingId == 0}">
                <el-tree ref="cateGoryTreeRef" :allow-drop="handleAllowDrop"
                         :data="groupingList"
                         :expand-on-click-node='false'
                         :props="{children: 'children',label: 'name'}"
                         @node-drop="handleNodeDrop"
                         @node-click="handleClickGroupingItem"
                         check-on-click-node
                         check-strictly
                         default-expand-all
                         node-key="id">
                    <div  class="custom_tree_node" slot-scope="{ node, data }">
                        <div   class="node_label ellipsis" :title="node.label">{{node.label }}</div>
                        <div @click.stop class="node_handle">
                            <el-dropdown  placement="bottom-end" size="small" trigger="click">
                                <span class="icon_wrap"> <i class="el-icon-more"></i></span>
                                <el-dropdown-menu class="treeDropDown" slot="dropdown">
                                    <el-dropdown-item v-if="data.level < 3" @click.native="handleClickAddChildGrouping(data)">增加子分组</el-dropdown-item>
                                    <el-dropdown-item @click.native="handleClickEditGrouping(data)">编辑分组</el-dropdown-item>
                                    <!-- <el-dropdown-item @click.native="handleClickUpDownGrouping(data)">下架</el-dropdown-item>-->
                                    <el-dropdown-item @click.native="handleClickDelGrouping(data)">删除分组</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </div>
                </el-tree>
            </div>
        </div>

        <div class="product_shelves_right">
            <div class="product_shelves_search_handle">
                <div class="product_shelves_search">
                    <el-input size="small" v-model="keywords" placeholder="请输入需要查询的内容"  clearable  @clear="handleClickSearch" @blur="handleClickSearch" ref="search_input_ref"  @keyup.enter.native="handleEnterSearch">
                        <i slot="suffix" class="el-icon-search" @click="handleClickSearch"></i>
                    </el-input>
                </div>
                <div class="product_shelves_handle">
                    <el-button type="primary" plain size="small" @click="handleClickTransfer()">批量转移</el-button>
                    <el-button type="primary" size="small" @click="handleClickAdd()">新增产品</el-button>
                </div>
            </div>
            <div class="product_shelves_table">
                <CustomVxeTable
                        :loading="loading"
                        ref="tableRef"
                        class="custom-table"
                        id="warehouseTable"
                        :tableData="tableData"
                        :reduceHeight="reduceHeight"
                        :isShowToolBar="true"
                        :empty-render="{ name: 'NotData' }"
                        :pagination.sync="pagination"
                        @handleCurrentChange="handleCurrentChange"
                        @handleSizeChange="handleSizeChange"
                        :customConfig="tableCustomConfig"
                        @selection-change="handleSelectionChange"  >
                    <vxe-column fixed="left" field="checkbox" type="checkbox" width="42"></vxe-column>
                    <vxe-column field="goods_name" title="产品名称"  min-width="184" show-overflow>
                        <template #default="{ row }">
                            <div class="goods_brand_name ellipsis" >
                                <p  class="goods_name ellipsis">
                                    <span class="template_color" @click="handleClickDetail(row)" v-text="row.goods_name"></span>
                                </p>
                                <span  class="brand_name ellipsis" v-if="row.brand_name" v-text="row.brand_name ? row.brand_name : ''"></span>
                            </div>
                        </template>
                    </vxe-column>
                    <vxe-column field="status" title="是否上架"  width="180" show-overflow>
                        <template #default="{ row }">
                            <div  style="display: flex;align-items: center">
                                <el-switch @change="handleChangeStatus(row)" v-model="row.status" :active-value="1" :inactive-value="0"  active-color="#2990FF"></el-switch><span class="ml_8" v-text="row.status == 1 ?'是' : '否'"></span>
                            </div>
                        </template>
                    </vxe-column>

                    <vxe-column field="operate" width="90" fixed="right">
                        <template #header>
                            <span>操作</span>
                            <el-tooltip class="item" effect="dark" content="表头设置" placement="bottom-start">
                                <i class="iconfont icon-biaotoushezhi table-header-icon" @click="handleClickCustom"></i>
                            </el-tooltip>
                        </template>
                        <template #default="{ row }">
                            <div class="table-operate-icon">
                                <span class="handle_icon_wrap" @click="handleClickEdit(row)"><i class="iconfont icon-bianji"></i></span>
                                <span class="line"></span>
                                <span class="handle_icon_wrap"  @click="handleClickDel(row)"><i class="iconfont icon-shanchu1"></i></span>
                            </div>
                        </template>
                    </vxe-column>
                    <template #empty>
                        <div class="custom-table-empty">
                            <div class="custom-table-empty-img">
                                <img src="https://download.hecoos.com/enlightv/2024-53/147a907c1ec9fd000d8e8b0b30dd0fba.svg" alt="">
                            </div>
                            <p class="custom-table-empty-txt">暂无上架产品，请点击新增产品添加</p>
                            <div>
                                <el-button type="primary"  size="small" @click="handleClickAdd">新增产品</el-button>
                            </div>
                        </div>
                    </template>

                </CustomVxeTable>
            </div>
        </div>

        <groupingTemplate :groupingVisible.sync="groupingVisible" v-if="groupingVisible" :groupingId="groupingId" :groupingPid="groupingPid" @success="getGoodsCategoryList()"/>
        <batchTransfer :bathTransferVisible.sync="bathTransferVisible" v-if="bathTransferVisible" :productIds="transferIdList" @success="batchTransferSuccess()"/>
        <ordinaryEdit :ordinaryEditVisible.sync="ordinaryEditVisible" v-if="ordinaryEditVisible" :goodsType="goodsType" :goodsId="goodsId" @success="getTableData()"/>
        <standardEdit :standardEditVisible.sync="standardEditVisible" v-if="standardEditVisible" :goodsType="goodsType" :goodsId="goodsId" @success="getTableData()"/>
        <combinationEdit :combinationEditVisible.sync="combinationEditVisible" v-if="combinationEditVisible" :goodsType="goodsType" :goodsId="goodsId" @success="getTableData()"/>
        <productDetail :productDetailVisible.sync="productDetailVisible" v-if="productDetailVisible" :goodsType="goodsType" :goodsId="goodsId"/>
    </div>
</template>

<script>
import {GoodsCategoryDel,GoodsCategoryList,GoodsCategoryUnlist,GoodsList,GoodsDel,setGoodsOnlineStatus} from "@/api"
import {pagination} from "@/mixins";
import CustomVxeTable from "@/components/pComponents/vxe-table";
import groupingTemplate from "./component/groupingTemplate.vue";
import batchTransfer from "./component/batch_transfer.vue";
import ordinaryEdit from "./component/ordinary_edit.vue";
import standardEdit from "./component/standard_edit.vue";
import combinationEdit from "./component/combination_edit.vue";
import productDetail from "./component/product_detail.vue";
import {mapState} from "vuex";


export default {
    name: "ProductShelves",
    components: {
        CustomVxeTable,
        groupingTemplate,
        batchTransfer,
        ordinaryEdit,
        standardEdit,
        combinationEdit,
        productDetail,
    },
    data() {
        return {
            loading:false,
            keywords:'',
            tableData:[],
            tableHeight:'',
            tableCustomConfig: {
                storage:true,
                allowFixed: false,
                confirmButtonText: "确定",
                resetButtonText: "重置",
                visibleMethod: (col) => {
                    return true;
                },
                checkMethod: (col) => {
                    return col.column.field !== "checkbox";
                },
                allowSort: true,
            },
            groupingList:[],
            activeGroupingId:0,
            activeGroupingName:'',
            groupingId:0,
            selectedList:[],
            groupingVisible:false,
            groupingPid:0,
            bathTransferVisible:false,
            transferIdList:[],
            goodsId:0,
            goodsType:'',
            ordinaryEditVisible:false,//库存产品编辑 自定义产品编辑
            standardEditVisible:false, //标准产品编辑
            combinationEditVisible:false, //组合产品编辑
            productDetailVisible:false,//产品详情

        };
    },
    mixins: [pagination],
    computed: {
        reduceHeight() {
            return  this.tableData.length ? 170 : 124;
        },
        ...mapState(['tagList'])
    },

    created() {
        this.getGoodsCategoryList()
        this.getTableData()
    },
    // 从上一页返回的时候刷新
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if(from.name == 'ProductShelvesAdd'){
                vm.handleClickSearch();
            }
        });
    },
    mounted() {

    },
    methods: {
        // 添加分组
        handleClickAddGrouping(){
            this.groupingId = 0
            this.groupingPid = 0
            this.groupingVisible = true
        },
        // 添加子分组
        handleClickAddChildGrouping(item){
            this.groupingId = 0
            this.groupingPid = item.id
            this.groupingVisible = true
        },
        // 编辑子分组
        handleClickEditGrouping(item){
            this.groupingId = item.id
            this.groupingPid = 0
            this.groupingVisible = true
        },
        // 分组上下架
        handleClickUpDownGrouping(item){
            const h = this.$createElement;
            let isDownUp = true
            if(!isDownUp){
                return false
            }
            this.$msgbox({
                title: '是否将分组下架',
                message: h('div', null, [
                    h('span', null, '下架后，分组中的产品也将全部下架'),
                ]),
                iconClass: `icon-jinggao iconfont prompt_message_icon status0`,
                customClass: 'prompt_message_custom',
                confirmButtonText:  '确认',
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: true,
                confirmButtonClass:  'el-button--danger',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        done();
                    } else {
                        done();
                    }
                }
            }).then(() => {
                GoodsCategoryUnlist({category_id:item.id}).then(res => {
                    if (res.code === 200) {
                        this.$message({
                            message: '下架成功',
                            type: 'success',
                            duration: 1000,
                            onClose: () => { }
                        })
                        this.getGoodsCategoryList()
                        if(this.activeGroupingId == item.id){
                            this.activeGroupingId = 0
                            this.getTableData()
                        }
                    }
                })
            }).catch(() => {

            })
        },
        // 删除分组
        handleClickDelGrouping(item){
            const h = this.$createElement;
            let isProduct = item.has_products
            let title = isProduct ? '请将分组中的产品转移至其他分组后再删除' : '是否要删除当前选择的产品分组，删除后不可恢复，是否继续？'
            this.$msgbox({
                title: '删除分组',
                message: h('div', null, [
                    h('span', null, title),
                ]),
                iconClass: `icon-jinggao iconfont prompt_message_icon ${isProduct ? 'status1' : 'status0'}`,
                customClass: 'prompt_message_custom',
                confirmButtonText:  isProduct ? '知道了' : '删除',
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: !isProduct,
                confirmButtonClass: !isProduct ? 'el-button--danger' : '',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        done();
                    } else {
                        done();
                    }
                }
            }).then(() => {
                if(isProduct){return false}
                GoodsCategoryDel({id:item.id}).then(res => {
                    if (res.code === 200) {
                        this.$message({
                            message: '删除成功',
                            type: 'success',
                            duration: 1000,
                            onClose: () => { }
                        })
                        this.getGoodsCategoryList()
                        if(this.activeGroupingId == item.id){
                            this.activeGroupingId = 0
                            this.getTableData()
                        }
                    }
                })
            }).catch(() => {

            })
        },
        // 点击分组
        handleClickGroupingItem(item){
            this.activeGroupingId  = item.id
            this.activeGroupingName  = item.name
            this.handleClickSearch()
        },
        handleAllowDrop(draggingNode, dropNode, type){
            return type === 'prev' || type === 'next'
            // if (draggingNode.data.level === dropNode.data.level) {
            //     if (draggingNode.data.pid === dropNode.data.pid) {
            //         return type === 'prev' || type === 'next'
            //     } else {
            //         return false;
            //     }
            // } else {
            //     // 不同级进行处理
            //     return false;
            // }
        },
        handleNodeDrop(draggingNode, dropNode, dropType, ev){
            let obj = {
                afterId: '', //移动的id
                arr: [],
                beforId: ''
            }
            obj.afterId = draggingNode.data.id // 移动的
            obj.beforId = dropNode.data.id   //  位置被换的
            this.isDrag = true
            this.handleClickDrag()
        },
        // 保存排序
        handleClickDrag(){
            let categoryList = JSON.parse(JSON.stringify(this.categoryList))

        },
        // 递归排序
        recursionSortFunction(data) {
            return data.map((item,key) => {
                const result = { id: item.id, sort: data.length -  key };
                // 如果有子项，则递归转换
                if (item.children) {
                    result.children = this.recursionSortFunction(item.children);
                }
                return result;
            });
        },
        // 批量转移
        handleClickTransfer(){
            if(this.selectedList.length == 0) {return this.$message.error('请至少选择一个产品')}
            let transferIdList = this.selectedList.map(item => {
                return item.goods_id
            })
            this.transferIdList = transferIdList
            this.bathTransferVisible = true
        },
        // 批量转移回调
        batchTransferSuccess(){
            this.selectedList = []
            this.getTableData()
        },
        // 新增产品
        handleClickAdd(){
            let index = this.tagList.findIndex(find => find.name == 'ProductShelvesAdd')
            this.$router.push({
                name: 'ProductShelvesAdd',
                query:{
                    category_id:this.activeGroupingId,
                    category_name:this.activeGroupingName
                },
                params: {
                    isPush: index > -1 ? false  : true,
                },
            })
        },
        // 编辑产品
        handleClickEdit(row){
            this.goodsId = row.goods_id
            this.goodsType = row.type
            if(row.type == 'custom' || row.type == 'stock'){
                this.ordinaryEditVisible = true //库存产品编辑 自定义产品编辑
            }else if(row.type == 'basic'){
                this.standardEditVisible = true //标准产品编辑
            }else{
                this.combinationEditVisible = true //组合产品编辑
            }
        },
        // 查看产品详情
        handleClickDetail(row){
            this.goodsId = row.goods_id
            this.goodsType = row.type
            this.productDetailVisible = true
        },
        handleChangeStatus(row){
          let postData = {
              goods_id: row.goods_id,
              status: row.status
          }
            setGoodsOnlineStatus(postData).then(res => {
                if (res.code === 200) {
                    this.$message({
                        message: '操作成功',
                        type: 'success',
                        duration: 1000,
                        onClose: () => { }
                    })
                }
            })
        },
        // 删除产品
        handleClickDel(row){
            const h = this.$createElement;
            this.$msgbox({
                title: '是否删除该产品？',
                message: h('div', null, [
                    h('span', null, '删除后，将无法在订单中下单，也无法在售后中进行损坏换新处理，请谨慎操作!'),
                ]),
                iconClass: `icon-jinggao iconfont prompt_message_icon status0`,
                customClass: 'prompt_message_custom',
                confirmButtonText:  '删除',
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: true,
                confirmButtonClass: 'el-button--danger',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        done();
                    } else {
                        done();
                    }
                }
            }).then(() => {
                let postData = {
                    goods_id: row.goods_id,
                    type: row.type
                }
                GoodsDel(postData).then(res => {
                    if (res.code === 200) {
                        this.$message({
                            message: '删除成功',
                            type: 'success',
                            duration: 1000,
                            onClose: () => { }
                        })
                        this.getTableData()
                    }
                })
            }).catch(() => {

            })
        },
        handleEnterSearch(){
            this.$nextTick(()=>{
                if(this.$refs.search_input_ref){
                    this.$refs.search_input_ref.blur()
                }
            })
        },
        // 搜索
        handleClickSearch(){
            this.pagination.pageNum = 1
            this.getTableData()
        },

        // 表头配置
        handleClickCustom() {
            this.$refs.tableRef.handleOpenCustomShow();
        },
        handleSizeChange(val) {
            this.pagination.pageNum = 1
            this.pagination.pageSize = val.pageSize
            this.getTableData()
        },
        handleCurrentChange(val) {
            this.pagination.pageNum = val
            this.getTableData()
        },
        // 获取产品分组
        getGoodsCategoryList(){
            let postData = {keyword:''}
            GoodsCategoryList(postData).then(res => {
                if (res.code === 200) {
                    this.groupingList = res.data

                }
            })
        },
        getTableData(){
            let postData = {
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                category_id:this.activeGroupingId ? this.activeGroupingId : '',
                keyword:this.keywords
            }
            this.loading = true
            GoodsList(postData).then(res => {
                if (res.code === 200) {
                    let {list,total} = res.data
                    this.tableData = list
                    this.pagination.total = total
                }
                this.loading = false
            })
        },
        // 表格复选框
        handleSelectionChange(ids) {
            this.selectedList = ids;
            this.$forceUpdate()
        },

    },
}
</script>

<style  lang="scss" scoped>
@import "@/styles/product_shelves.scss";
.el-popper{
    margin-top: 2px;
}
::v-deep .vxe-table-custom--panel-list>li.is--hidden{
    display: none;
}
</style>